export enum PeriodTypeValue {
  Minute = 1,
  Hour = 2,
  Daily = 3,
  Weekly = 4,
  Monthly = 5,
  Yearly = 6
}
